export default "/_next/static/images/img3-fa36eeabe1e27ec42ef57acf91472c97.png";